import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import Select from "react-select";
import DatePicker from "react-datepicker";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { DecisionSwal } from "Utils/Utils/DecisionSwal";
import { ResumenExistenciaContenido } from "../../../../components/Existencia/ResumenExistenciaContenido";
import { CierreMensualSeccion } from "./CierreMensualSeccion";
import { PieCierreMensual } from "./PieCierreMensual";
import { useCierreMensual } from "../hooks/useCierreMensual";
import {
    TIPO_COMPLETO,
    descripcionRegistro,
} from "../../../../helpers/tiposCierreMensual";

// Registro de un cierre mensual: se elige el período, después qué se cierra de
// él —el completo o una sola mitad del formato— y se previsualiza antes de
// registrarlo
export const ConsultaCierreMensual = ({ onRegresar }) => {
    const cierreMensual = useCierreMensual(onRegresar);

    const {
        periodos,
        periodo,
        tipo,
        opcionesTipo,
        incluyeBodega,
        fechaCorte,
        fechaMinimaCorte,
        horasCorte,
        resumen,
        puedeConsultar,
        puedeCerrar,
    } = cierreMensual;

    const tipoSeleccionado =
        opcionesTipo.find((opcion) => opcion.value === tipo) || null;

    // Cualquier cierre mensual congela el período de almacenes, y el de bodega
    // además el cierre de bodega que usa
    const RegistrarCierreMensual = () => {
        const documento = incluyeBodega
            ? " El cierre de inventario de bodega utilizado ya no podrá anularse."
            : "";

        const mensaje =
            (tipo === TIPO_COMPLETO ? "Se registrarán los " : "Se registrará el ") +
            descripcionRegistro(tipo) +
            " del período " +
            periodo.periodo +
            ". El inventario de almacenes del período ya no podrá reabrirse." +
            documento;

        DecisionSwal(mensaje, "Sí, registrar", "Cancelar", () =>
            cierreMensual.RegistrarCierre(),
        );
    };

    return (
        <div className="reporte-inventarios__tab-wrapper">
            <CardEmpty noShadow>
                <LoadMask loading={cierreMensual.cargando} blur>
                    <div className="reporte-inventarios__table-header">
                        <div className="formulario-fields-row">
                            <div className="formulario-field min-w-200">
                                <label htmlFor="periodo" className="m-0">
                                    Período
                                </label>
                                <Select
                                    inputId="periodo"
                                    className="react-select-container"
                                    isSearchable
                                    options={periodos}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.periodo}
                                    value={periodo}
                                    onChange={(opcion) =>
                                        cierreMensual.SeleccionarPeriodo(opcion)
                                    }
                                    placeholder="Seleccione un período"
                                    noOptionsMessage={() =>
                                        "No hay períodos pendientes de cerrar"
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 20,
                                        }),
                                    }}
                                />
                            </div>

                            {/* el ancho deja leer completa la opción más larga */}
                            <div
                                className="formulario-field"
                                style={{ minWidth: 260 }}
                            >
                                <label htmlFor="tipo" className="m-0">
                                    Tipo de cierre
                                </label>
                                <Select
                                    inputId="tipo"
                                    className="react-select-container"
                                    options={opcionesTipo}
                                    value={tipoSeleccionado}
                                    onChange={(opcion) =>
                                        cierreMensual.CambiarTipo(opcion.value)
                                    }
                                    isDisabled={!periodo}
                                    placeholder="Seleccione un período"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 20,
                                        }),
                                    }}
                                />
                            </div>

                            {incluyeBodega && (
                                <div className="formulario-field min-w-150">
                                    <label htmlFor="fecha_corte" className="m-0">
                                        Fecha y hora de corte
                                    </label>
                                    <DatePicker
                                        selected={fechaCorte}
                                        onChange={cierreMensual.CambiarFechaCorte}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                        showPopperArrow={false}
                                        dateFormat="DD/MM/YYYY HH:mm"
                                        placeholderText="Fecha y hora de corte"
                                        minDate={fechaMinimaCorte}
                                        minTime={horasCorte.minima}
                                        maxTime={horasCorte.maxima}
                                        disabled={!periodo}
                                    />
                                </div>
                            )}

                            <button
                                className="btn btn-primary mt-auto"
                                onClick={cierreMensual.Consultar}
                                disabled={!puedeConsultar}
                            >
                                Consultar
                            </button>
                        </div>
                        <div className="ml-auto formulario-fields-row flex-nowrap">
                            <div className="formulario-field">
                                <button
                                    className="btn btn-outline-dark mt-auto text-nowrap"
                                    onClick={onRegresar}
                                >
                                    Regresar
                                </button>
                            </div>
                        </div>
                    </div>

                    <CierreMensualSeccion cierreMensual={cierreMensual} />

                    {!resumen && (
                        <div className="text-center py-5">
                            <h3>No hay datos disponibles</h3>
                        </div>
                    )}

                    {resumen && (
                        <React.Fragment>
                            <ResumenExistenciaContenido
                                resumen={resumen}
                                omitirSeccionesVacias
                                observacionesProductos={
                                    cierreMensual.observacionesProductos
                                }
                                onCambiarObservacion={
                                    puedeCerrar
                                        ? cierreMensual.CambiarObservacionProducto
                                        : null
                                }
                            />

                            <PieCierreMensual
                                cierreMensual={cierreMensual}
                                onRegistrar={RegistrarCierreMensual}
                            />
                        </React.Fragment>
                    )}
                </LoadMask>
            </CardEmpty>
        </div>
    );
};
